"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountUpdate = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var mona_1 = require("@artegeie/design-system/mona");
var user_1 = require("@artegeie/mona-sdk/user");
var form_1 = require("../../form");
var schemas_1 = require("../../../validation/schemas");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var useYupForm_1 = __importDefault(require("../../../context/useYupForm"));
var style_1 = require("../../style");
var layout_1 = require("../../layout");
var accountFormSchema = (0, schemas_1.createSchema)({
    email: schemas_1.email,
    confirmEmail: schemas_1.confirmEmail,
});
var AccountUpdate = function (_a) {
    var _b, _c;
    var _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, onCancel = _a.onCancel, onSubmit = _a.onSubmit;
    var _e = (0, useYupForm_1.default)(accountFormSchema), control = _e.control, handleSubmit = _e.handleSubmit, reset = _e.reset, setAPIError = _e.setAPIError, _f = _e.formState, errors = _f.errors, isSubmitSuccessful = _f.isSubmitSuccessful;
    var messages = (0, useFormattedMessages_1.default)('form.profile.account');
    var serverValidationMessages = (0, useFormattedMessages_1.default)('server');
    var resetForm = function () { return reset({
        email: '',
        confirmEmail: '',
    }, {
        keepErrors: false,
        keepDirty: false,
        keepValues: false,
        keepDefaultValues: false,
        keepIsSubmitted: false,
        keepTouched: false,
        keepIsValid: false,
        keepSubmitCount: false,
    }); };
    var onFormCancel = function () {
        resetForm();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    };
    var onFormSubmit = function (accountToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, user_1.postNewEmail)(accountToUpdate.email)];
                case 1:
                    _a.sent();
                    resetForm();
                    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    message = error_1.message;
                    setAPIError(message);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (0, jsx_runtime_1.jsx)(mona_1.Modal, __assign({ id: "AccountUpdate", isOpen: isOpen, onClose: onFormCancel, title: messages.modify }, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ name: "AccountUpdateForm" }, { children: [(0, jsx_runtime_1.jsxs)(style_1.Spacer, __assign({ spacer: mona_1.lSpacer }, { children: [(0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.mSpacer }, { children: (0, jsx_runtime_1.jsx)(style_1.Typography, { children: messages['modal.message'] }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.xxsSpacer }, { children: (0, jsx_runtime_1.jsx)(form_1.Input, { type: 'email', label: messages.newEmail, name: 'email', control: control, errorType: (_b = errors === null || errors === void 0 ? void 0 : errors.email) === null || _b === void 0 ? void 0 : _b.type, errorValues: {
                                    maxCharacters: schemas_1.emailMaxCharacters,
                                } }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.xxsSpacer }, { children: (0, jsx_runtime_1.jsx)(form_1.Input, { type: 'email', label: messages.confirmNewEmail, name: 'confirmEmail', control: control, errorType: (_c = errors === null || errors === void 0 ? void 0 : errors.confirmEmail) === null || _c === void 0 ? void 0 : _c.type, errorValues: {
                                    maxCharacters: schemas_1.emailMaxCharacters,
                                } }, void 0) }), void 0), errors.APIError && errors.APIError.type &&
                            (0, jsx_runtime_1.jsx)(form_1.FormValidationError, { children: serverValidationMessages[errors.APIError.type] || serverValidationMessages['generic'] }, void 0), isSubmitSuccessful && (0, jsx_runtime_1.jsx)(form_1.FormValidationSuccess, { children: messages['modal.success'] }, void 0)] }), void 0), (0, jsx_runtime_1.jsxs)(layout_1.ActionRow, { children: [(0, jsx_runtime_1.jsx)(form_1.PrimaryButton, { value: messages.save, onClick: handleSubmit(onFormSubmit) }, void 0), (0, jsx_runtime_1.jsx)(mona_1.Link, { href: "#", onClick: onFormCancel, label: messages.cancel }, void 0)] }, void 0)] }), void 0) }), void 0);
};
exports.AccountUpdate = AccountUpdate;
exports.default = exports.AccountUpdate;
